module.exports = __webpack_public_path__ + "img/zs-3.d69f6054.png";